module.exports = __webpack_public_path__ + "b2972118be9e912d839eda8ba4ebc277.pdf";